import styled from 'styled-components';

export const TagStyled = styled.div`
  width: 100%;
  height: 100%;
  min-height: 14rem;
  background-color: ${props => props.theme.color.wfYellow};
  padding: ${props => props.theme.spacing.large};
  display: flex;
  justify-content: space-between;
  &:hover {
    background-color: ${props => props.theme.color.wfYellow700};
  }
`;
